import { ComponentPropsWithRef, forwardRef, ReactNode } from "react";
import PrettySelectStyle from "./css/PrettySelect.module.css";
import clsx from "clsx";
import Text from "./Text";
type PrettySelectProps = ComponentPropsWithRef<"input"> & {
    variant?: "dashed" | "dotted" | "solid";
    leftIcon?: React.ReactNode;
    rightIcon?: React.ReactNode;
    fullWidth?: boolean;
    value: string;
    id?: string;
    name?: string;
    text: string;
    textAlign?: "left" | "center" | "right";
    checked?: boolean;
    defaultChecked?: boolean;
    isSelectAll?: boolean;  // "전체" 옵션인지 여부
    onSelectAllChange?: (name: string, checked: boolean) => void;  // 전체 선택/해제 콜백
};

const PrettySelect = forwardRef<HTMLInputElement, PrettySelectProps>(({ 
    type = "checkbox", 
    variant, 
    leftIcon, 
    rightIcon, 
    fullWidth = false, 
    width,
    value, 
    id, 
    text, 
    name, 
    style, 
    onChange, 
    checked, 
    textAlign = "left",
    defaultChecked,
    isSelectAll = false,
    onSelectAllChange,
    ...props 
}, ref) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // "전체" 버튼인 경우, 콜백을 통해 부모에게 알림
        if (isSelectAll && onSelectAllChange && name) {
            onSelectAllChange(name, e.target.checked);
        }
        onChange?.(e);
    }
    
    return (
        <div
            className={clsx(
                PrettySelectStyle['pretty-select-wrap'],
                variant && PrettySelectStyle[variant],
                isSelectAll && PrettySelectStyle['select-all'],
            )}
            style={{
                width: fullWidth ? "100%" : width,
                ...style
            }}
        >
            <input
                id={id}
                name={isSelectAll ? undefined : name}  // "전체" 버튼은 form data에 포함하지 않음
                ref={ref}
                type="checkbox"
                value={value}
                checked={checked}
                defaultChecked={defaultChecked}
                onChange={handleChange}
                className={clsx(
                    PrettySelectStyle['pretty-select'],
                )}
                {...props}
                />
            <div
                className={clsx(
                    PrettySelectStyle['pretty-select-display'],
                )}
                tabIndex={-1}
            >
                {leftIcon && <div className={PrettySelectStyle['pretty-select-icon']}>{leftIcon}</div>}
                <Text style={{width: "100%", textAlign: textAlign}}>{text}</Text>
                {rightIcon && <div className={PrettySelectStyle['pretty-select-icon']}>{rightIcon}</div>}

            </div>
        </div>
    )
});

PrettySelect.displayName = "PrettySelect";

export default PrettySelect;